<template>
  <div>
    <px-view-header title="Banners" :breadcrumbs="breadcrumbs"/>
    <div class="mt-5">
      <listagem-banner-header :on-click-refresh="onClickRefresh"
                               :on-change-filter="onChangeFilter"/>
      <lista-banner :banners="banners" :loading="loading"
                     :on-change-options="onChangeOptions"
                     :options-list="optionsList"
                     @update="onUpdate"/>
    </div>
  </div>
</template>

<script>
import paginationMixin from '@/mixins/pagination-mixin';
import ListaBanner from './ListaBanner.vue';
import ListagemBannerHeader from './ListagemBannerHeader.vue';
import BannerService from './banner-service';

export default {
  mixins: [paginationMixin],
  methods: {
    onChangeFilter(filter) {
      this.listOptions.filter = filter;
      this.resetPage();
      this.getBanners();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getBanners();
    },
    onClickRefresh() {
      this.getBanners();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    getBanners() {
      this.loading = true;
      const { limit, offset } = this.listOptions;
      return BannerService.getBanners({
        limit,
        offset,
        query: this.buildQuery(this.listOptions),
      })
        .then((response) => {
          this.banners = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onUpdate() {
      this.getBanners();
    },
  },
  components: {
    ListaBanner,
    ListagemBannerHeader,
  },
  data() {
    return {
      banners: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 25,
        offset: 0,
        filter: '',
        sort: 'descricao',
        sortDesc: true,
      },
      loading: false,
      breadcrumbs: [
        { text: 'Marketplace' },
        { text: 'Banners' },
      ],
      optionsList: {},
    };
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
  },
};
</script>
